import { drawStripedPattern } from '../lib/striped-pattern-canvas';

const instances = new WeakMap();

const getTargets = (root = document) => {
	const scope = root && typeof root.querySelectorAll === 'function' ? root : document;
	const targets = Array.from(scope.querySelectorAll('.striped-pattern'));

	if (root instanceof Element && root.matches('.striped-pattern')) {
		targets.unshift(root);
	}

	return targets.filter((canvas) => !(canvas.dataset.module || '').trim());
};

const scheduleDraw = (canvas) => {
	const instance = instances.get(canvas);

	if (!instance || instance.rafId) {
		return;
	}

	instance.rafId = window.requestAnimationFrame(() => {
		instance.rafId = null;
		drawStripedPattern(canvas);
	});
};

const setupCanvas = (canvas) => {
	if (instances.has(canvas)) {
		scheduleDraw(canvas);
		return;
	}

	const instance = {
		observer: null,
		rafId: null,
	};

	instances.set(canvas, instance);

	if ('ResizeObserver' in window) {
		instance.observer = new ResizeObserver(() => scheduleDraw(canvas));
		instance.observer.observe(canvas);
	} else {
		window.addEventListener('resize', () => scheduleDraw(canvas), { passive: true });
	}

	scheduleDraw(canvas);
};

export default function init(root = document) {
	getTargets(root).forEach(setupCanvas);
}
